import {
	ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioInvestmentTypeEnum,
	type PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const getIsActive = (
	startAt: string | undefined | null,
	endAt: string | undefined | null,
	isOneTime: boolean,
) => {
	const now = new Date();
	const startDate = startAt ? new Date(startAt) : now;

	const todayDateOnly = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
	);
	const startDateOnly = new Date(
		startDate.getFullYear(),
		startDate.getMonth(),
		startDate.getDate(),
	);

	if (isOneTime) {
		return todayDateOnly.getTime() === startDateOnly.getTime();
	}

	const hasStarted = startDateOnly <= todayDateOnly;

	if (!endAt) {
		return hasStarted;
	}

	const endDate = new Date(endAt);
	const endDateOnly = new Date(
		endDate.getFullYear(),
		endDate.getMonth(),
		endDate.getDate(),
	);

	return hasStarted && todayDateOnly <= endDateOnly;
};

export const toolHasActivePeriodicPurchaseInstructions = (
	tool: PortfolioDetailResponseDTO["tools"][0],
): boolean => {
	const hasActiveCommodityPurchase = tool.commodities?.some((commodity) => {
		const isOneTime =
			commodity.frequency === ClientPortfolioInvestmentFrequencyEnum.Once;
		const isPurchase =
			commodity.investmentType === undefined ||
			commodity.investmentType === null ||
			commodity.investmentType === ClientPortfolioInvestmentTypeEnum.Buy;
		const isActive = commodity.startAt
			? getIsActive(commodity.startAt, commodity.endAt, isOneTime)
			: false;

		return !isOneTime && isPurchase && isActive;
	});

	if (hasActiveCommodityPurchase) return true;

	const hasActiveCryptoPurchase = tool.cryptocurrencyInstructions?.some(
		(instruction) => {
			const isOneTime =
				instruction.frequency === ClientPortfolioInvestmentFrequencyEnum.Once;
			const isPurchase =
				instruction.investmentType === undefined ||
				instruction.investmentType === null ||
				instruction.investmentType === ClientPortfolioInvestmentTypeEnum.Buy;
			const isActive = instruction.date
				? getIsActive(instruction.date, instruction.endedAt, isOneTime)
				: false;

			return !isOneTime && isPurchase && isActive;
		},
	);

	if (hasActiveCryptoPurchase) return true;

	const hasActiveInvestmentPurchase = tool.investments?.some((investment) => {
		const isOneTime =
			investment.frequency === ClientPortfolioInvestmentFrequencyEnum.Once;
		const isPurchase =
			investment.investmentType === undefined ||
			investment.investmentType === null ||
			investment.investmentType === ClientPortfolioInvestmentTypeEnum.Buy;
		const isActive = investment.startAt
			? getIsActive(investment.startAt, investment.endAt, isOneTime)
			: false;

		return !isOneTime && isPurchase && isActive;
	});

	return hasActiveInvestmentPurchase;
};

export const hasActivePeriodicPurchaseInstructions = (
	baseData: PortfolioDetailResponseDTO,
): boolean =>
	baseData.tools.some((tool) =>
		toolHasActivePeriodicPurchaseInstructions(tool),
	);
